import './clickableSectionList.scss';
import {ClickableElement} from './clickableSectionList';
import classNames from 'clsx';
import {Icons} from '../../../../../icons/icons';
import {useTranslation} from 'react-i18next';
import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import {SvgIcon} from '../../../../../icons/svgIcon';
import {useDispatch} from 'react-redux';
import {setScrollTargetAction} from '../../../../duck/search-actions';
import {FilterWidget} from '../../../../../common/filterWidget/filterWidget';

export const DocumentSectionsRenderer = (clickableElements: ClickableElement[] | null) => {
    const {t} = useTranslation();
    const [expanded, setExpanded] = useState<boolean>(true);
    const [filter, setFilter] = useState('');
    const dispatch = useDispatch();

    if (clickableElements && clickableElements.length === 0) {
        return null;
    }

    const onElementClick = (element: ClickableElement) => {
        dispatch(setScrollTargetAction(element));
    };

    return (
        <div>
            <div className={'sections-list-header'}>
                <div onClick={() => setExpanded(!expanded)} className={classNames('toggle-header')}>
                    <Button className="toggle-button">
                        <SvgIcon icon={Icons.CHEVRON_DOWN} className={expanded ? 'expanded' : ''} />
                    </Button>
                    <div className={'toggle-label'}>{t('fieldTitle.tagsPlural.documentSectionsHeader.label')}</div>
                </div>
                {expanded && (
                    <FilterWidget
                        filter={filter}
                        setFilter={setFilter}
                        title={t('fieldTitle.tagsPlural.documentSectionsHeader.label')}
                    />
                )}
            </div>
            {expanded && (
                <ul className={classNames('sections-list')}>
                    {clickableElements
                        ?.filter((el) => !filter || el.label.toLowerCase().includes(filter.toLowerCase()))
                        .map((element) => (
                            <li
                                onClick={() => onElementClick(element)}
                                key={'id_' + element.label}
                                className={classNames('sections-element', 'documentSection-element')}
                            >
                                <span>{element.label}</span>
                            </li>
                        ))}
                </ul>
            )}
        </div>
    );
};
